import { twMerge } from 'tailwind-merge';
import { InfoTip } from '@/components/Help/InfoTip';
import type { HelpTip } from '@/docs/tips/types';

interface TableTitleProps {
  text: string;
  textClassName?: string;
  /** "i" icon explaining the table. */
  infoTip?: HelpTip;
}

export const TableTitle = ({
  text,
  textClassName,
  infoTip,
}: TableTitleProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center gap-1.5 text-black-071336 font-semibold dark-mode:text-gray-500',
        textClassName,
      )}
    >
      {text}
      {infoTip && <InfoTip tip={infoTip} />}
    </div>
  );
};
